
























































import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import GLastStudentsEntryModal from '@/views/GAcademicPromotion/GLastStudentsEntryModal.vue';
import GPromotionCompleteModal from '@/views/GAcademicPromotion/GPromotionCompleteModal.vue';
import { schoolClassModule } from '@/store/modules/entities/school-class.module';
import { GradeSchoolClass, SchoolClass } from '@/models/school-class/school-class';
import GSchoolClassesEntryModal from '@/components/GSchoolClassesEntryModal.vue';
import { teacherModule } from '@/store/modules/entities/teacher.module';
import { TeacherSearch } from '@/models/teacher/teacher-search';
import { Teacher } from '@/models/teacher/teacher';
import { studentModule } from '@/store/modules/entities/student.module';
import { Student } from '@/models/student/student';
import { StudentSearch } from '@/models/student/student-search';
import { cookieService } from '@/service/cookie.service';
import { Header, SubMenu } from '@/constants/constants';
import { GEnum } from '@/constants/enum.defination';
import GStepCard from '@/views/GAcademicPromotion/GStepCard.vue';
import { globalModule } from '@/store/modules/global.module';
import { GPageBase } from '@/mixins';
import { activeMenuStorageService } from '@/service/storage/active-menu-storage.service';

Component.registerHooks(['beforeRouteEnter']);
@Component({
  name: 'GAcademicPromotion',
  components: { GStepCard, GSchoolClassesEntryModal, GLastStudentsEntryModal, GCustomBreadCrumb, GPromotionCompleteModal },
  computed: {},
  methods: {},
})
export default class GAcademicPromotion extends Mixins(GPageBase) {
  breadCrumbItems: any[] = [];
  modalLastSchoolClassesEntry: boolean = false; // クラス一括登録確認用モーダル
  modalLastStudentsEntry: boolean = false; // 進級確認モーダル
  modalPromotionComplete: boolean = false; // 完了モーダル
  lazy: boolean = false;
  lastSchoolClasses: SchoolClass[] = [];

  beforeRouteEnter(to: any, from: any, next: any) {
    next((vm: any) => {
      if (vm.isCompletedInitialSetting) {
        vm.$Modal.info({
          title: vm.isPromotion ? vm.$t('COMPLETE_PROMOTION_SETTING').toString() : vm.$t('COMPLETE_INIT_SETTING').toString(),
          content: vm.isPromotion ? vm.$t('MESSAGE_ACADEMIC_PROMOTION_30').toString() : vm.$t('MESSAGE_COMPLETE_ALL_SETTING').toString(),
          okText: 'OK',
        });
        next({ path: '/pages/home' });
      }
    });
  }

  async mounted() {
    // 初期設定の場合は登録者情報ページに飛ばす
    if (!this.isPromotion) {
      this.handleStudentSettingButton();
    }

    this.breadCrumbItems = [{ title: this.$t('HOME').toString(), icon: 'ios-home', routerPath: '/pages/home' }, { title: this.isPromotion ? this.$t('PROMOTION_SETTING').toString() : this.$t('INIT_SETTING').toString() }];

    // 昨年度のクラスを取得
    // 昨年度のクラスが無い場合は進級処理が行えないためボタンを非活性にするために取得
    await schoolClassModule.fetchSchoolClasses({ [Header.SchoolYear]: cookieService.schoolYearInt - 1 }).then((response: SchoolClass[]) => {
      this.lastSchoolClasses = response.map((schoolClass: SchoolClass) => new SchoolClass().deserialize(schoolClass));
    });

    await teacherModule.fetchTeacherList({ offset: 0, limit: 0 } as TeacherSearch);
    await studentModule.fetchStudents({} as StudentSearch);
    this.lazy = true;
  }

  handleAddLastSchoolClasses() {
    schoolClassModule.fetchGradesSchoolClasses({ [Header.SchoolYear]: cookieService.schoolYearInt - 1 }).then(() => {
      const newGradeSchoolClasses: GradeSchoolClass[] = this.gradeSchoolClasses.map((gradeSchoolClass: GradeSchoolClass) => {
        gradeSchoolClass.schoolClasses.forEach((schoolClass: SchoolClass) => {
          schoolClass.created = true;
        });
        return gradeSchoolClass;
      });
      schoolClassModule.setGradeSchoolClasses(newGradeSchoolClasses);
      this.modalLastSchoolClassesEntry = true;
    });
  }

  setActiveMenu(menuID: string) {
    activeMenuStorageService.activeMenu = menuID;
    globalModule.setActiveMenu(menuID);
  }

  handleStudentSettingButton() {
    this.setActiveMenu(SubMenu.StudentSetting.menuID);
    this.$router.push(SubMenu.StudentSetting.path);
  }

  handleTeacherSettingButton() {
    this.setActiveMenu(SubMenu.TeacherSetting.menuID);
    this.$router.push(SubMenu.TeacherSetting.path);
  }

  handleSchoolClassSettingButton() {
    this.setActiveMenu(SubMenu.SchoolClassSetting.menuID);
    this.$router.push(SubMenu.SchoolClassSetting.path);
  }

  handlePromotionComplete() {
    this.modalPromotionComplete = true;
  }

  handleOpenManualWindow() {
    window.open(
      this.$t('AIGROW_MANUAL_URL_PROMOTION_1').toString(),
      'popupWindow',
      'width=740,height=800,noopener,noreferrer'
    );
  }

  get isRoleNormal(): boolean {
    return this.$store.state.account.isRoleNormal;
  }

  get isCompletedInitialSetting(): boolean {
    return this.$store.state.account.isCompletedInitialSetting;
  }

  get selectedSchoolYear(): number {
    return globalModule.selectedSchoolYear;
  }

  get step(): number {
    let current: number = 0;
    if (this.completedStepThreeStudentSetting) {
      current++;
    }

    return current;
  }

  get isPromotion(): boolean {
    return this.$store.state.account.isPromotion;
  }

  get stepOneSchoolClassSetting(): GEnum.IntroductionStep {
    return GEnum.IntroductionStep.StepOneSchoolClassSetting;
  }

  get stepTwoTeacherSetting(): GEnum.IntroductionStep {
    return GEnum.IntroductionStep.StepTwoTeacherSetting;
  }

  get stepThreeStudentSetting(): GEnum.IntroductionStep {
    return GEnum.IntroductionStep.StepThreeStudentSetting;
  }

  get completedStepOneSchoolClassSetting(): boolean {
    return this.schoolClasses.length > 0;
  }

  get completedStepTwoTeacherSetting(): boolean {
    return teacherModule.isAllAssignSchoolClasses;
  }

  get completedStepThreeStudentSetting(): boolean {
    return this.students.length > 0;
  }

  get gradeSchoolClasses(): GradeSchoolClass[] {
    return schoolClassModule.gradeSchoolClasses;
  }

  get schoolClasses(): SchoolClass[] {
    return schoolClassModule.schoolClasses;
  }

  get teachers(): Teacher[] {
    return teacherModule.teachers;
  }

  get students(): Student[] {
    if (studentModule.students === undefined) {
      return [];
    }
    return studentModule.students.data;
  }
}
